import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/PageHeader';
import { INFORMATIVA } from '@/content/informativaCondomini';

// Informativa completa sul trattamento dei dati dei condomini. Il testo sta in un unico file (content/informativaCondomini.js, generato).
export const InformativaCondomini = () => (
  <div className="space-y-6 max-w-3xl">
    <PageHeader title={INFORMATIVA.titolo} description={INFORMATIVA.sottotitolo} />
    <p className="text-xs text-muted-foreground">Versione del {INFORMATIVA.dataTesto}</p>
    {INFORMATIVA.sezioni.map((s) => (
      <Card key={s.id} id={s.id}>
        <CardContent className="pt-6 space-y-3 text-sm leading-relaxed">
          <h2 className="text-base font-semibold">{s.titolo}</h2>
          {(s.paragrafi || []).map((p, i) => <p key={`p${i}`}>{p}</p>)}
          {s.elenco && <ul className="list-disc ml-5 space-y-1">{s.elenco.map((e, i) => <li key={i}>{e}</li>)}</ul>}
          {s.tabella && (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead><tr>{s.tabella.intestazioni.map((h) => <th key={h} className="border px-3 py-2 text-left bg-muted/50">{h}</th>)}</tr></thead>
                <tbody>{s.tabella.righe.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} className="border px-3 py-2 align-top">{c}</td>)}</tr>)}</tbody>
              </table>
            </div>
          )}
          {(s.dopo || []).map((p, i) => <p key={`d${i}`}>{p}</p>)}
        </CardContent>
      </Card>
    ))}
  </div>
);

export default InformativaCondomini;
